export default (props, children) => [ ...children ]